import QRCode from 'qrcode'

function toDataURL ({data, mode, color} = {})
{
    const opts =
    {
        errorCorrectionLevel: 'H',
        type: 'image/png',
        quality: 0.92,
        margin: 1,
        scale: 20,
        color
    }

    return QRCode.toDataURL([{data, mode}], opts)
}

export default { toDataURL }


// WEBPACK FOOTER //
// ./src/utils/QRCodeUtils.js